@switch (state()) {
  @case ('loading') {
    <div class="loading">
      <ion-spinner name="bubbles"></ion-spinner>
      <p>Loading data...</p>
    </div>
  }
  @case ('empty') {
    @if (searchTextEmpty()) {
      <div class="empty no-search">
        <p>No results found</p>
      </div>
    } @else {
      <div class="empty">
        <h2>No results found</h2>
        <p>If you are looking for prescription medications, please upload your script to get started.</p>
        <app-button (click)="goToAddScript()" label="Upload your eScript" [fitContent]="true" />
      </div>
    }
  }
  @case ('error') {
    <div class="empty">
      <h2>Oops! Something went wrong</h2>
      <p>Try again later</p>
    </div>
  }
  @case ('results') {
    <div class="list">
      <app-product-grid [products]="itemList()" />
      <ion-infinite-scroll threshold="100px" [disabled]="infiniteScrollDisabled()" (ionInfinite)="triggerLoadData($event)">
        <ion-infinite-scroll-content
          loadingSpinner="bubbles"
          loadingText="Loading more data...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>
  }
}